import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight, Star } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferCTA() {
  return <section id="precio" className="w-full px-6 py-16 md:py-24 bg-charcoal border-t border-white/5 relative overflow-hidden" data-id="element-105">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-rose/10 via-charcoal to-charcoal opacity-50 pointer-events-none" data-id="element-106"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-107">
        <FadeIn data-id="element-108">
          <div className="flex justify-center gap-2 mb-8" data-id="element-109">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 text-gold fill-gold" data-id="element-110" />)}
          </div>

          <h2 className="text-5xl md:text-6xl lg:text-7xl mb-8 text-white font-serif" data-id="element-111">
            Empieza hoy mismo
          </h2>

          <p className="text-xl md:text-2xl text-linen mb-10 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-112">
            Si quieres dejar de pelear contigo misma por las noches y empezar a
            sentirte liviana de forma realista.
          </p>

          <div className="bg-linen p-10 md:p-14 shadow-2xl border border-white/10 mb-10 max-w-2xl mx-auto relative" data-id="element-113">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-rose via-gold to-rose" data-id="element-114"></div>

            <h3 className="text-3xl font-bold text-charcoal mb-3 font-serif" data-id="element-115">
              BARRIGA REBELDE (PERI)
            </h3>
            <p className="text-muted mb-8 font-light tracking-wide uppercase text-sm" data-id="element-116">
              PDF + plantillas + menú rotativo + tracker
            </p>

            <div className="flex items-baseline justify-center gap-4 mb-8" data-id="element-117">
              <span className="text-6xl md:text-7xl font-serif text-charcoal" data-id="element-118">
                $6.36
              </span>
              <span className="text-2xl text-muted/50 line-through font-serif" data-id="element-119">
                $29
              </span>
            </div>

            <a href="https://momentumdigitalpro.com/cart/44499594117222:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="w-full bg-rose hover:bg-rose-light text-white font-medium text-lg tracking-[0.2em] uppercase py-5 transition-all shadow-xl hover:shadow-2xl flex items-center justify-center gap-3 rounded-none group no-underline" data-id="element-120">
              Descargar ahora
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-121" />
            </a>

            <p className="text-xs text-muted mt-6 tracking-wide" data-id="element-122">
              PAGO SEGURO • ACCESO INMEDIATO
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}